<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    class="fly-icon-spinner"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#0074FF" fill-rule="nonzero">
        <g>
          <g>
            <path
              d="M12 24c-1.799 0-3.528-.389-5.142-1.155l1.285-2.71C9.354 20.709 10.65 21 12 21c4.963 0 9-4.037 9-9s-4.037-9-9-9-9 4.037-9 9c0 1.351.291 2.649.867 3.858l-2.709 1.288C.39 15.531 0 13.8 0 12 0 5.383 5.383 0 12 0c6.616 0 12 5.383 12 12 0 6.616-5.384 12-12 12z"
              transform="translate(-520 -82) translate(496 56) translate(24 26)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'SpinnerIcon',
  props: {
    height: VueTypes.string.def('24'),
    width: VueTypes.string.def('24'),
  },
};
</script>

<style lang="scss">
@keyframes fly-icon-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.fly-icon-spinner {
  animation-name: fly-icon-spin;
  animation-duration: 500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>
